import { borderRadius } from './borderRadius';
import { borderWidths, borderStyles, borders } from './borders';
import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { shadows } from './shadows';
import { space } from './space';
import { transitions } from './transitions';
import { fontSizes, fontWeights, lineHeights } from './typography';
import { zIndices } from './zIndices';

export const theme = {
  colors,
  space,
  fontSizes,
  fontWeights,
  lineHeights,
  borderRadius,
  shadows,
  zIndices,
  transitions,
  breakpoints,
  borderWidths,
  borderStyles,
  borders,
}; 